import { render, staticRenderFns } from "./IconSvgMEMAAHome.vue?vue&type=template&id=1cb3597c&scoped=true&"
import script from "./IconSvgMEMAAHome.vue?vue&type=script&lang=js&"
export * from "./IconSvgMEMAAHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3597c",
  null
  
)

export default component.exports